jQuery(function(){

    var gifts = 0;
    jQuery('body').on('submit', '.gift-membership-recipients__save-form', function(e){
        var $form = jQuery(this);
        $form.addClass('gift-membership-recipients__save-form--disabled');
        $form.parent('.gift-membership-recipients__recipient').find('.gift-membership-recipients__remove').removeClass('gift-membership-recipients__remove--hidden');
        $form.parent('.gift-membership-recipients__recipient').find('.gift-membership-recipients__edit').removeClass('gift-membership-recipients__edit--hidden');

		$form.parent('.gift-membership-recipients__recipient').removeClass('gift-membership-recipients__recipient--open');

        $form.addClass('gift-membership-recipients__save-form--disabled');
        var $heading = $form.prev('.gift-membership-recipients__recipient');

        $heading.find('.gift-membership-recipients__remove').removeClass('gift-membership-recipients__remove--hidden');
        $heading.find('.gift-membership-recipients__edit').removeClass('gift-membership-recipients__edit--hidden');

		$form.parent('.gift-membership-recipients__recipient').next('.gift-membership-recipients__recipient').addClass('gift-membership-recipients__recipient--open');
        var $next_form = $form.parent('.gift-membership-recipients__recipient').next('.gift-membership-recipients__recipient').find('.gift-membership-recipients__save-form');
        $next_form.removeClass('gift-membership-recipients__save-form--disabled');

        var $next_heading = $next_form.prev('.gift-membership-recipients__recipient');

        $next_heading.find('.gift-membership-recipients__remove').addClass('gift-membership-recipients__remove--hidden');
        $next_heading.find('.gift-membership-recipients__edit').addClass('gift-membership-recipients__edit--hidden');
        gifts++;
        return false;
    });


    jQuery('body').on('submit', '.gift-membership-recipient__form', function(e){
        var $form = jQuery(this);
        e.preventDefault();

        if(gifts === jQuery('.gift-membership-recipients__save-form').length) {
            window.location.href = '/membership/gift/information';
        } else {
            jQuery('.gift-membership-recipients__save-form:not(.gift-membership-recipients__save-form--disabled):first').submit();
        }

    });


	jQuery('body').on('click', '.gift-membership-recipients__edit', function(e){
		var $form = jQuery(this).closest('.gift-membership-recipients__recipient').find('.gift-membership-recipients__save-form');
		jQuery(this).closest('.gift-membership-recipients__recipient').addClass('gift-membership-recipients__recipient--open');
		$form.removeClass('gift-membership-recipients__save-form--disabled');
		return false;
    });

    // * CNCI-336 - check first before modaal
    if (jQuery(".gift-membership-recipients__remove").length) {

        jQuery('.gift-membership-recipients__remove').modaal({
            type: 'confirm',
            overlay_opacity: 0.5,
            confirm_button_text: 'Remove',
            confirm_cancel_button_text: 'Cancel',
            hide_close: false,
            confirm_content: '<p class="modaal__copy">Are you sure you want to remove this membership?</p>',
            confirm_callback: function() {
                var $this = jQuery(this.$elem);

                var $form = $this.closest('.gift-membership-recipients__save-form');

                var price = $this.data('price') * 1.13;
                var total = parseFloat(jQuery('#progress-bar-total').html());
                total = total - price;
                jQuery('#progress-bar-total').html(total.toFixed(2));

                var $container;

                if($form.length === 0) {
                    $container = $this.closest('.gift-membership-recipients__recipient');
                    $form = $container.find('.gift-membership-recipients__save-form');
                } else {
                    $container = $form.parent('.gift-membership-recipients__recipient');

                    var $next = $container.next('.gift-membership-recipients__recipient');
                    $next.addClass('gift-membership-recipients__recipient--open');

                    var $next_form = $next.find('.gift-membership-recipients__save-form');

                    $next.find('.gift-membership-recipients__remove').addClass('gift-membership-recipients__remove--hidden');
                    if($next_form.length) {
                        $next_form.removeClass('gift-membership-recipients__save-form--disabled');
                    }
                }

                $form.remove();
                $container.remove();

            }
        });

        jQuery('body').on('click', '.modaal__close-link', function(e) {
            jQuery('.gift-membership-recipients__remove').modaal('close');
        });
    }

    jQuery('body').on('submit', '.gift-info__form', function(e){
        e.preventDefault();
        window.location.href = '/membership/gift/payment';
	});

	//******************** Playground Validation JS conflict with our
	//Flows and login pages so IT requested to remove it. Plus we use sitecore forms, so this is not needed anyways.

    // if(jQuery('.gift-membership__form').length > 0) {
	// 	jQuery('.gift-membership__form').parsley({
	// 	excluded: '',
	// 	inputs: 'input[type=hidden], :hidden'
	// 	}).on('form:validate', function(form){
	// 		var error = true;
	// 		jQuery("input[type=hidden]").each(function(index, ele){
    //             if(jQuery(ele).val())
    //                 error = false;

    //             return;
    //         });

    //         if(error === false) {
	// 			form.submitEvent.preventDefault();
	// 			window.location.href = '/membership/gift/recipient';
	// 		} else {
	// 			var $form = form.$element;
	// 			if(jQuery('.form__error').length === 0) {
    //                 jQuery("html, body").animate({ scrollTop: 0 }, "medium");
	// 				jQuery('.gift-membership__heading:first').after('<div class="form__error form__error--white _breaks-container"><a name="error"></a>* You must select a Membership type before continuing.</div>');
	// 			}

	// 		}

	// 		return error;
	// 	});
	// }

	//****** Link from membership/gift to membership/gift/recipient will be broken,
	//but that's fine as we don't use playground gift flow(this)
});
